var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M635.373 262.156L483.374 470.156C478.858 476.344 471.655 480 463.999 480H463.921C456.218 479.969 449.015 476.25 444.515 470.031L175.86 96.875L43.377 278.156C35.518 288.844 20.502 291.156 9.846 283.375C-0.857 275.562 -3.201 260.531 4.627 249.844L156.626 41.844C161.142 35.656 168.345 32 176.001 32H176.079C183.782 32.031 190.985 35.75 195.485 41.969L464.14 415.125L596.623 233.844C604.435 223.094 619.467 220.812 630.154 228.625C640.857 236.438 643.201 251.469 635.373 262.156Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveTriangle);
export default __webpack_public_path__ + "static/media/wave-triangle.21916c3c316a483e800843f0589f5d32.svg";
export { ForwardRef as ReactComponent };